import { Outlet } from "react-router-dom";
import NavigationLearning from "../../components/containers/navigation/navigationLearning";

function ActivityLayout() {
  return (
    <>
      <NavigationLearning title="죽을때 까지 기억나는 JavaScript  기초부터 응용까지 | Chapter 1" />
      <div className="mt-16 h-full">
        <Outlet />
      </div>
    </>
  );
}

export default ActivityLayout;
